import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-runway-large.tsx
/**
* icon.24.logo.runway.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE2LjI2MiA0YzQuNTkzIDAgNS4wMzEgNi44MzQuNDkyIDcuNDQ4bDIuMTYgMi4xNDZjMi4zNjUgMi4yMjguNTg4IDYuNDktMi42NTEgNi4zOTVsLS4wMDEuMDAxYy0xLjk0MS4xNzgtMy41NTQtMi4wOS00Ljc5OC0zLjIzOC0uNjI5IDQuNTIzLTcuNDY0IDQuMS03LjQ2NC0uNDkzVjcuNzQ1YzAtLjY3LjE3OC0xLjM1My41MzMtMS45MjdDNS4xOSA0LjcxMSA2LjQ2IDMuOTg2IDcuNzQ1IDR6bS00Ljc3MSA5LjU1NCAzLjIyNiAzLjIyNS41MDYuNTA2YzEuMzQgMS4zOCAzLjQ3Mi0uNzUyIDIuMDkyLTIuMDkybC0zLjczMy0zLjczaC0yLjA5MXpNOS4yMiA3LjczYy4wMjgtLjk1Ni0uOTgzLTEuNzA3LTEuODk4LTEuNDJhMS41IDEuNSAwIDAgMC0xLjA2NyAxLjQ0OHY4LjQ4N2guMDEzYy0uMDI3IDEuOTEzIDIuOTk0IDEuOTEzIDIuOTUzIDB6bTEuOTctMS40NzVjLjM4Mi44MDYuMjg2IDIuMDc3LjMgMi45NTJoNC43NzFjMS45MTQuMDI3IDEuOTE0LTIuOTggMC0yLjk1MnoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26873-63548
*/
const Icon24LogoRunwayLarge = memo(function Icon24LogoRunwayLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M16.262 4c4.593 0 5.031 6.834.492 7.448l2.16 2.146c2.365 2.228.588 6.49-2.651 6.395l-.001.001c-1.941.178-3.554-2.09-4.798-3.238-.629 4.523-7.464 4.1-7.464-.493V7.745c0-.67.178-1.353.533-1.927C5.19 4.711 6.46 3.986 7.745 4zm-4.771 9.554 3.226 3.225.506.506c1.34 1.38 3.472-.752 2.092-2.092l-3.733-3.73h-2.091zM9.22 7.73c.028-.956-.983-1.707-1.898-1.42a1.5 1.5 0 0 0-1.067 1.448v8.487h.013c-.027 1.913 2.994 1.913 2.953 0zm1.97-1.475c.382.806.286 2.077.3 2.952h4.771c1.914.027 1.914-2.98 0-2.952z"
		})
	});
});
//#endregion
export { Icon24LogoRunwayLarge };

//# sourceMappingURL=icon-24-logo-runway-large.js.map